import {Col, Row} from "antd";
import {CallList} from "./components/List";
import {Info} from "./components/Info";

export const IntelligentOutboundCall = () => {
  return <>
  <Row wrap={false}>
    <Col flex="440px">
      <CallList/>
    </Col>
    <Col flex="auto">
      <Info/>
    </Col>
  </Row>
  </>
}